// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"efb2af5d","453":"5d42c66d"}[chunkId] + ".chunk.js";
};